<template>
  <div class="row">
    <div class="columns">
      <div class="container">
        <div class="isSaving" v-if="isSaving">
          <i class="fal fa-circle-notch fa-spin fa-3x fa-fw text-info"></i>
        </div>

        <!--UPLOAD-->
        <form v-else enctype="multipart/form-data" novalidate>
          <div class="dropbox" :class="{ empty: !logoUrl }">
            <input
              type="file"
              name="logo"
              accept="image/*"
              :disabled="isSaving"
              @change="
                logoUpload($event.target.name, $event.target.files);
                fileCount = $event.target.files.length;
              "
              class="input-file"
            />
            <h4 v-if="!logoError">
              Drag your logo here or click to browse.
              <span>
                <h5>Maximum file size: 2MB</h5>
              </span>
              <span>
                <h5>Allowed file types: {{ approvedTypes }}</h5>
              </span>
            </h4>

            <div v-else-if="logoErrorType == 'size'">
              <h4 class="alert">Logos must be under 2MB in size.</h4>
              <h4>Please try again with a smaller image.</h4>
            </div>

            <div v-else-if="logoErrorType == 'type'">
              <h4 class="alert">
                Logos can only be {{ approvedTypes }} files.
                <span>
                  <h5>Maximum file size: 2MB</h5>
                </span>
              </h4>
            </div>

            <img :src="logoUrlRandomString" v-if="logoUrlRandomString && logoUrlRandomString.length > 0" />
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
'use strict';
import { mapGetters } from 'vuex';
	const STATUS_INITIAL = 0
  const STATUS_SAVING = 1
  const STATUS_SUCCESS = 2
  const STATUS_FAILED = 3;

export default {
  name: 'LogoUpload',
  data() {
    return {
      loading: true,
      uploadedFiles: [],
      uploadError: null,
      currentStatus: null,
      uploadFieldName: 'logo',
      isSaving: false,
      uploadError: false,
      approvedTypes: 'jpg, png, gif',
    };
  },

  methods: {
    save(formData) {
      // upload data to the server
      this.currentStatus = STATUS_SAVING;

      this.upload(formData)
        .then((x) => {
          this.isSaving = false;
          this.currentStatus = STATUS_SUCCESS;
        })
        .catch((err) => {
          this.isSaving = false;
          this.uploadError = err.response;
          this.currentStatus = STATUS_FAILED;
        });
    },

    upload(formData) {
      return this.$store.dispatch('UPLOAD_LOGO', formData);
    },

    logoUpload(fieldName, fileList) {
      // handle file changes
      this.isSaving = true;
      const formData = new FormData();

      if (!fileList.length) {
        return false;
      }
      // append the files to FormData

      for (let i = 0; i < fileList.length; i++) {
        formData.append(fieldName, fileList[i], fileList[i].name);
      }

      // save it
      this.save(formData);
    },
  },

  computed: {
    ...mapGetters(['logoUrl', 'logoError', 'logoErrorType']),
    logoUrlRandomString() {
      return this.logoUrl + '?rand=' + Math.random();
    },
  },

  components: {},

  beforeMount() {
    // this.setting = this.$root.$el.dataset.settingName;
    // this.label = this.$root.$el.dataset.settingLabel;
  },

  mounted() {},
  created() {},
};
</script>

<style lang="scss" scoped>
h5 {
  margin: 0;
}

[v-cloak] {
  display: none;
}

.dropbox {
  background: #fff;
  color: dimgray;
  padding: 10px 10px;
  min-height: 200px; /* minimum height */
  position: relative;
  cursor: pointer;
  display: grid;
  align-items: center;
}

.dropbox.empty {
  outline: 4px dashed #f8f8f8; /* the dash box */
  outline-offset: -5px;
}

.input-file {
  opacity: 0; /* invisible but it's there! */
  width: 100%;
  height: 200px;
  position: absolute;
  cursor: pointer;
}

.dropbox:hover {
  background: #fdfdfd; /* when mouse over to the drop zone, change color */

  outline: 4px dashed #083850; /* the dash box */
  outline-offset: -5px;
}

.container {
  display: grid;
  grid-template-rows: 300px;
  align-items: center;
}

.container .isSaving {
  margin: 0 auto;
}

.container p {
  font-size: 0.9em;
  text-align: center;
  font-weight: 600;
}

.container h4 {
  text-align: center;
}

.dropbox img {
  display: block;
  margin: 0 auto;
  max-width: 300px;
  max-height: 250px;
}
#previewFrame {
  width: 100%;
  height: 300px;
}
</style>
